/*
 * Tiryakioğlu bölümlerinin davranışları (prototip: tiryakioglu-kaynak-website/index.html).
 * Reveal, okuma efekti ve sayaçlar şablonun theme.js'inde. Burada: header, vitrin, şeritler, modallar.
 * Tema editöründe bölüm yeniden çizilince (shopify:section:load) yalnızca o bölüm yeniden kurulur.
 */
(() => {
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  /* ── Header: banner üstünde şeffaf, kaydırınca beyaz; mobil menü ── */
  function initHeader(root = document) {
    const header = root.querySelector ? root.querySelector('#header') || (root.id === 'header' ? root : null) : null;
    const h = header || document.getElementById('header');
    if (!h || h.dataset.tkInit) return;
    h.dataset.tkInit = '1';
    const solid = h.classList.contains('is-solid');
    let state = null;
    const set = () => { const v = solid || window.scrollY > 60; if (v !== state) { state = v; h.classList.toggle('scrolled', v); } };
    window.addEventListener('scroll', set, { passive: true });
    set();
    const btn = h.querySelector('#menu-btn');
    const menu = h.querySelector('#mobile-menu');
    if (btn && menu) {
      const close = () => {
        menu.classList.remove('open'); btn.setAttribute('aria-expanded', 'false');
        h.querySelector('#icon-open')?.classList.remove('hidden'); h.querySelector('#icon-close')?.classList.add('hidden');
      };
      btn.addEventListener('click', () => {
        const open = menu.classList.toggle('open');
        btn.setAttribute('aria-expanded', String(open));
        h.querySelector('#icon-open')?.classList.toggle('hidden', open);
        h.querySelector('#icon-close')?.classList.toggle('hidden', !open);
      });
      menu.querySelectorAll('a').forEach((a) => a.addEventListener('click', close));
    }
  }

  /* ── Banner ürün vitrini: 4 sn'de bir döner, üzerine gelince durur ── */
  function initShowcase(root = document) {
    $$('[data-showcase]', root).forEach((sc) => {
      if (sc.dataset.tkInit) return;
      sc.dataset.tkInit = '1';
      const items = $$('.sc-item', sc);
      const tabs = $$('.sc-tabs button', sc);
      const no = sc.querySelector('[data-sc-no]');
      const cta = sc.querySelector('[data-sc-cta]');
      const base = sc.dataset.waBase || 'https://wa.me/';
      const tpl = sc.dataset.waTemplate || '[model]';
      let i = 0, timer;
      const show = (n) => {
        i = (n + items.length) % items.length;
        items.forEach((el, k) => el.classList.toggle('is-active', k === i));
        tabs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', String(k === i)); });
        if (no) no.textContent = String(i + 1).padStart(2, '0');
        if (cta) cta.href = base.split('?')[0] + '?text=' + encodeURIComponent(tpl.replace('[model]', items[i].dataset.waModel || ''));
      };
      const play = () => { clearInterval(timer); if (items.length > 1 && !window.Shopify?.designMode) timer = setInterval(() => show(i + 1), 4000); };
      tabs.forEach((t, k) => t.addEventListener('click', () => { show(k); play(); }));
      sc.addEventListener('mouseenter', () => clearInterval(timer));
      sc.addEventListener('mouseleave', play);
      show(0); play();
    });
  }

  /* ── Yatay şeritler: oklar + ilerleme çubuğu ── */
  function initRails(root = document) {
    $$('[data-rail]', root).forEach((r) => {
      if (r.dataset.tkInit) return;
      r.dataset.tkInit = '1';
      const sec = r.closest('section');
      const bar = sec?.querySelector('[data-rail-progress]');
      $$('[data-rail-dir]', sec).forEach((b) => b.addEventListener('click', () => {
        const card = r.firstElementChild;
        if (!card) return;
        const step = (card.offsetWidth + 20) * (window.innerWidth >= 1024 ? 2 : 1);
        r.scrollBy({ left: step * Number(b.dataset.railDir), behavior: 'smooth' });
      }));
      if (bar) {
        const update = () => {
          const ratio = Math.min(1, r.clientWidth / Math.max(1, r.scrollWidth));
          const pos = r.scrollLeft / Math.max(1, r.scrollWidth - r.clientWidth);
          bar.style.width = (ratio * 100) + '%';
          bar.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
        };
        r.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    });
  }

  /* ── Ürün grubu pencereleri ── */
  let lastFocus = null;
  function openModal(m) {
    lastFocus = document.activeElement;
    m.classList.remove('hidden');
    document.documentElement.style.overflow = 'hidden';
    window.lenis?.stop?.();
    m.querySelector('[data-modal-close].focus-ring, button')?.focus();
  }
  function closeModal(m) {
    m.classList.add('hidden');
    document.documentElement.style.overflow = '';
    window.lenis?.start?.();
    lastFocus?.focus?.();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-modal-open]');
    if (opener) {
      const m = document.getElementById(opener.dataset.modalOpen);
      if (m) { e.preventDefault(); openModal(m); }
      return;
    }
    const closer = e.target.closest('[data-modal-close]');
    if (closer) { const m = closer.closest('[data-modal]'); if (m) closeModal(m); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-modal]:not(.hidden)').forEach(closeModal);
  });

  /* ── Form gönderildiyse başarı mesajına odaklan ── */
  function initContact(root = document) {
    const ok = root.querySelector?.('[data-lead-success]');
    if (ok) setTimeout(() => ok.scrollIntoView({ block: 'center' }), 300);
  }

  function init(root = document) {
    initHeader(root); initShowcase(root); initRails(root); initContact(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    // editörde vitrin bloğu seçilince o ürünü göster
    const fig = e.target.closest?.('.sc-item');
    const sc = fig?.closest('[data-showcase]');
    if (sc) { const idx = [...sc.querySelectorAll('.sc-item')].indexOf(fig); sc.querySelectorAll('.sc-tabs button')[idx]?.click(); }
    const m = e.target.closest?.('[data-modal]');
    if (m) openModal(m);
  });
})();
